// extracted by mini-css-extract-plugin
export default {"header":"navbar_header__9qSnJ","aivotLogo":"navbar_aivotLogo__JsKID","apolloLogo":"navbar_apolloLogo__5MTmR"};